// @flow

import Api from './ApiBase';

class EntryLevelsApi extends Api {
  fetch = async () => {
    const json = await this.request('entry_levels');
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new EntryLevelsApi();
